import React, {
  useContext, useState, useEffect, useRef, useCallback,
} from 'react';
import { Container } from '@mui/material';
import './styles.css';
import { UserContext } from '../../providers/UserProvider';
import AddBuilderForm from '../../common/salescenter/addBuilderForm/index';
import SalesCenterSummaryTable from '../../common/salescenter/salesCenterSummaryTable';

const Home = () => {
  const userContext = useContext(UserContext);
  const [salesCenterList, setSalesCenterList] = useState([]);
  const latestDataRef = useRef({});
  const [, forceUpdate] = useState(0);

  const getLatestSalesCenter = useCallback((builderId) => {
    return latestDataRef.current[builderId];
  }, []);

  useEffect(() => {
    userContext.socket.emit('retrieveSalesCenters');

    userContext.socket.on('refreshSalesCenters', (results) => {
      const newMap = {};
      results.forEach((sc) => { newMap[sc.builderId] = sc; });
      latestDataRef.current = newMap;

      setSalesCenterList((prev) => {
        const prevIds = new Set(prev.map((sc) => sc.builderId));
        const newIds = new Set(results.map((sc) => sc.builderId));
        const structuralChange = prev.length !== results.length
          || results.some((sc) => !prevIds.has(sc.builderId))
          || prev.some((sc) => !newIds.has(sc.builderId));

        if (structuralChange) {
          return results;
        }
        forceUpdate((n) => n + 1);
        return prev;
      });
    });
  }, [userContext.socket]);

  return (
    <Container fixed maxWidth="lg">
      <div className="pageContainer">
        <AddBuilderForm salesCenterList={salesCenterList} />
        <SalesCenterSummaryTable
          salesCenterList={salesCenterList}
          getLatestSalesCenter={getLatestSalesCenter}
        />
      </div>
    </Container>
  );
};

export default Home;
